import styled from "styled-components";


export const TermsAndConditionsSection = styled.div`
  display: flex;
  align-items: start;
  padding: 16px 0;
  color: #6C757D;
  font-size: 16px;
  line-height: 24px;

  & > div {
    height: max-content;
  }
  & p {
    margin: 0;
  }
  &  a {
    text-decoration: underline;
  }
`;